import { convertToDocedBoxFeature } from "resha"
import { DocumentExtraction } from "universal-schema/lib/1.0.0/document-schema"
import {
    AnnotationFieldContent,
    AnnotationFieldKeyValue,
    AnnotationFields
} from "universal-schema/lib/1.0.0/annotation"

import { randID } from "../../../../../Helpers/Functions/random"
import {
    DataFieldType,
    FieldStatus
} from "../../../../../Models/DataProgram/DocumentExtraction"
import { AnnotationsOutputList } from "../DocumentsExtractionContext"
import {
    BoundingBoxStatus,
    BoundingBoxStatusStyles,
    DEFAULT_SCHEMA,
    ACTIVE_STYLE,
    NON_TRUSTED_STYLE,
    TRUSTED_STYLE
} from "./constants"

export const convertToStyledDocedBoxFeature = (
    annotations: DocumentExtraction,
    status: BoundingBoxStatus
) => {
    const { shapesState, docedFeatures } = convertToDocedBoxFeature(annotations)
    return {
        shapesState,
        boundingBoxes: docedFeatures.map(boundingBox => ({
            ...boundingBox,
            style: BoundingBoxStatusStyles[status]
        }))
    }
}

export const getDefaultDocumentExtraction = (
    pageNumber: number
): DocumentExtraction => ({
    ...(DEFAULT_SCHEMA as Omit<DocumentExtraction, "schema_instance">),
    schema_instance: {
        annotations: {
            [`${randID()}`]: [
                {
                    content: "",
                    boundingBox: {
                        top: 200,
                        left: 200,
                        width: 200,
                        height: 200
                    },
                    pageNumber
                }
            ]
        },
        url: "",
        totalPages: pageNumber
    }
})

export const getAnnotationDocumentExtraction = (
    annotations: AnnotationFields
): DocumentExtraction => ({
    ...(DEFAULT_SCHEMA as Omit<DocumentExtraction, "schema_instance">),
    schema_instance: {
        annotations,
        url: "",
        totalPages: 0
    }
})

export const isKeyValueAnnotation = (
    annotation: AnnotationFieldContent | AnnotationFieldKeyValue
): annotation is AnnotationFieldKeyValue => {
    return "key" in (annotation as AnnotationFieldKeyValue)
}

export const isTableAnnotation = (
    annotation: AnnotationFieldContent | AnnotationFieldKeyValue
): annotation is AnnotationFieldContent => {
    const content = (annotation as AnnotationFieldContent).content
    return (
        content !== null &&
        !Array.isArray(content) &&
        typeof content === "object"
    )
}

export const getCurrentColorClass = (status?: BoundingBoxStatus) => {
    let currentColor = ""
    if (status === BoundingBoxStatus.NON_TRUSTED) {
        currentColor = NON_TRUSTED_STYLE.classname
    } else if (status === BoundingBoxStatus.TRUSTED) {
        currentColor = TRUSTED_STYLE.classname
    } else {
        currentColor = ACTIVE_STYLE.classname
    }
    return currentColor
}

export const checkFieldValid = (
    outputAnnotationsId: string | undefined,
    { status, options }: DataFieldType,
    annotations?: AnnotationsOutputList
) => {
    const isActive = status.data === FieldStatus.Active
    const isAnnotationRequired = options.data.requireAnnotations.selection
    const annotationsLength = outputAnnotationsId
        ? annotations?.annotations[outputAnnotationsId]?.length
        : -1
    return isActive && isAnnotationRequired ? annotationsLength : true
}
